// extracted by mini-css-extract-plugin
export var wordContainer = "_rs-0";